
namespace GeniuzPOS.ReportMasterData {

    @Serenity.Decorators.registerClass()
    export class Report_1335Dialog extends Serenity.EntityDialog<Report_1335Row, any> {
        protected getFormKey() { return Report_1335Form.formKey; }
        protected getIdProperty() { return Report_1335Row.idProperty; }
        protected getLocalTextPrefix() { return Report_1335Row.localTextPrefix; }
        protected getNameProperty() { return Report_1335Row.nameProperty; }
        protected getService() { return Report_1335Service.baseUrl; }
        protected getDeletePermission() { return Report_1335Row.deletePermission; }
        protected getInsertPermission() { return Report_1335Row.insertPermission; }
        protected getUpdatePermission() { return Report_1335Row.updatePermission; }

        protected form = new Report_1335Form(this.idPrefix);

    }
}